__webpack_require__.p = "https://static.www.yuugeai.com/static/";